<h3>RCR Fees Schedule</h3>
<ul *ngFor="let feeData of rcrFeeScheduleData; trackBy: trackByIdentity">
  <li>{{ feeData }}</li>
</ul>
